export default __webpack_public_path__ + "static/frame-0b06caba423beb2cce2ca6c9a088f90d.png";